import ImportButton from "@/app/shared/import-button";
import CreateEditShipment from "@/app/shared/logistics/shipment/create-edit";
import { shipmentData } from "@/app/shared/logistics/shipment/create-edit/form-utils";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { useParams } from "react-router-dom";

const pageHeader = {
    title: "Edit Shipment",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Dashboard",
        },
        {
            href: routes.logistics.shipmentList,
            name: "Shipments",
        },
        {
            name: "Edit Shipment",
        },
    ],
};

export default function EditShipmentsPage() {
    const { id } = useParams();
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <ImportButton title={"Import File"} />
            </PageHeader>

            <CreateEditShipment id={id} shipment={shipmentData} />
        </>
    );
}
